import { __BuyWithdrawMethodConvertBoxProps, __BuyWithdrawMethodsEnums } from './buyWithdrawMethod.interface';
import { __TypeOfOrderEnum } from '../initial/initial.interface';
import BuyCryptoWithdrawMethod from './crypto/buyCryptoWithdrawMethod.index';
import BuyUUSDWithdrawMethod from './uusd/buyUUSDWithdrawMethod.index';
import { useRef, useState } from 'react';
import { API } from 'data/30pay.api';
import { post } from 'scripts';
import { ConvertBoxDataType } from '../convertBox.index';
import { __BuyPaymentMethodsEnum } from '../buyPaymentMethod/buyPaymentMethod.interface';
import ConvertBoxConfirmOrderModal from '30pay/trade/convertBox/confirmOrderModal/orderDetailModal.index';
import { useNavigate } from 'react-router-dom';
import { __ConvertBoxConfirmOrderDetailModalRef } from '../confirmOrderModal/orderDetailModal.interface';
import { toast } from 'react-toastify';

const BuyWithdrawMethod: React.FC<__BuyWithdrawMethodConvertBoxProps> = (props: __BuyWithdrawMethodConvertBoxProps) => {
    const [loading, setLoading] = useState(false);
    const [confirmData, setConfirmData] = useState<ConvertBoxDataType>();
    const [paymentUrl, setPaymentUrl] = useState<string>();
    const confirmModalRef = useRef<__ConvertBoxConfirmOrderDetailModalRef>(null);

    const navigate = useNavigate();

    function submitHandler(e?: ConvertBoxDataType) {
        confirmModalRef.current?.startLoading();
        const { data } = props;
        const UUSDBody = {
            source: props.data?.buyPaymentMethod === __BuyPaymentMethodsEnum.Gateway ? 1 : 0,
            platform: 1,
            amount: data?.srcValue,
            cardNumberId: data?.bankAccountId,
        };
        const CryptoBody = {
            ...UUSDBody,
            destinationSymbol: data?.destCoin?.symbol,
            walletAddress: confirmData?.walletAddress,
            network: confirmData?.network?.network,
        };
        const api = data?.destCoin?.symbol === 'UUSD' ? API.orderTransaction.buyUUSD : API.orderTransaction.buyCrypto;
        const body = data?.destCoin?.symbol === 'UUSD' ? UUSDBody : CryptoBody;
        post<any>(api, body)
            .then((res) => {
                if (res.value.value.paymentUrl) {
                    toast.info('در حال انتقال به درگاه پرداخت...', { autoClose: 2000 });
                    setTimeout(() => window.location.replace(res.value.value.paymentUrl), 2000);
                } else {
                    confirmModalRef.current?.showResultContent(true, res.value.value.trackingCode, {
                        state: res.value.value.state,
                    });
                    confirmModalRef.current?.stopLoading();
                }
            })
            .catch((e) => {
                confirmModalRef.current?.showResultContent(false);
                confirmModalRef.current?.stopLoading();
            });
    }

    return (
        <>
            <ConvertBoxConfirmOrderModal
                ref={confirmModalRef}
                data={confirmData}
                isOpen={!!confirmData}
                onClose={(needReFetch) => {
                    setConfirmData(undefined);
                    if (needReFetch) props.onFinish();
                }}
                submitButton={{
                    title:
                        props.data?.buyPaymentMethod === __BuyPaymentMethodsEnum.Gateway
                            ? 'انتقال به درگاه'
                            : 'تایید سفارش',
                    onClick: () => submitHandler(),
                }}
            />
            {props.data?.destCoin?.symbol === 'UUSD' ? (
                <BuyUUSDWithdrawMethod
                    loading={loading}
                    onSubmit={(e) => setConfirmData({ ...props.data, ...e })}
                    onBack={props.onBack}
                    data={props.data}
                />
            ) : (
                <BuyCryptoWithdrawMethod
                    loading={loading}
                    onSubmit={(e) => setConfirmData({ ...props.data, ...e })}
                    onBack={props.onBack}
                    data={props.data}
                />
            )}
        </>
    );
};
export default BuyWithdrawMethod;
